import React, { useState, useEffect } from "react";
import Modal from "components/base/Modal";
import classNames from "classnames";
import css from "../style.scss";
import { useDispatch } from "react-redux";
import { deleteBatchDialerIntegration } from "data/user/actions";
import ToastNotification from "../../components/ToastNotification";

const RemoveBatchDialer = ({ isOpen, onClose,integrationId }) => {

    const dispatch = useDispatch();
    const [showToast, setShowToast] = useState(false);

    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleRemove = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const result = await dispatch(deleteBatchDialerIntegration(integrationId));
            if (result && result.success) {
                setShowToast(true);
                onClose();
                setTimeout(() => setShowToast(false), 2000);
            }
        } catch (err) {
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            {showToast && (
                <ToastNotification
                    message="BatchDialer disconnected successfully"
                    show={true}
                />
            )}
            <Modal
                isOpen={isOpen}
                onClose={onClose}
                uniqId="RemoveBatchDialerModal"
                width="auto"
                padding="0"
                modalClassName={css.pricingModal}
                className={classNames(css.clsAccPageModals, css.clsBillingModal)}
            >
                <div className={classNames(css.modal_lg, "modal-dialog modal-lg m-0 modal-dialog-scrollable")}>
                    <div className={classNames(css.clsModalContent, "modal-content")}>
                        <div className={classNames(css.removeBatchDialerModal, "modal-body")}>
                            <div className={css.rbModalTextGroup}>
                                <div className={css.rbModalTitle}>Remove API Connection?</div>
                                <div className={css.rbModalDetails}>
                                    Once removed, you’ll need to reconnect using <br></br> your API key.
                                </div>
                            </div>

                            <div className={css.buttonRemoveWrapper}>
                                <button className={css.cancelRemoveBtn} onClick={onClose}>
                                    <span className={css.cancelRemoveLabel}>Cancel</span>
                                </button>
                                <button className={classNames(css.connectModalRmvBtn, { [css.noClick]: isSubmitting })} onClick={handleRemove}>
                                    <span className={css.connectRmvBtnLabel} >Remove</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default RemoveBatchDialer;